import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";

import "./styles/index.css";
import App from "./App.jsx";
import * as serviceWorker from "./serviceWorker";
import { PostHogConfig } from "./components/PostHogConfig";
import { queryClient } from "./utils/queryClient";
import { applyTheme, getStoredTheme } from "./utils/themes";

applyTheme(getStoredTheme());

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <QueryClientProvider client={queryClient}>
    <PostHogConfig>
      <App />
    </PostHogConfig>
  </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. This comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
